import {Component, OnInit} from '@angular/core';
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import { GET_PROMOTIONS_FEATURED } from "../../graphql/graphql.queris";
import {Apollo} from "apollo-angular";
import {saltosDeLinea, convertirPrimeraLetraMayuscula} from "../../utils/utilities";
import {RouterLink} from "@angular/router";
import {environment} from "../../../environments/environment";


@Component({
  selector: 'app-promotions-featured',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    RouterLink,
    NgStyle
  ],
  templateUrl: './promotions-featured.component.html',
  styleUrl: '../promotions-person/promotions-list/promotions-list.component.css'
})
export class PromotionsFeaturedComponent implements OnInit{
  promotions: any[] = [];
  protected promotionsVisibles: any[] = [];
  serverImgenUrl =environment.imgUrl;


  constructor(
    private apollo: Apollo,

  ) {
  }

  ngOnInit() {

    this.apollo
      .watchQuery({
        query: GET_PROMOTIONS_FEATURED,
        variables: {limit: 3},
        fetchPolicy: 'no-cache'
      })
      .valueChanges.subscribe((result: any) => {
      this.promotions = result.data.getPromotionsFeatured
        .flat();
      this.promotionsVisibles = this.promotions.sort((a, b) => {
        return  new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime() ;
      });
    });
  }

  protected readonly saltosDeLinea = saltosDeLinea
  protected readonly convertirPrimeraLetraMayuscula = convertirPrimeraLetraMayuscula

}
